import { Directive, ElementRef, HostBinding, Input, OnChanges, OnInit, Renderer2, SimpleChanges, inject } from '@angular/core';

@Directive({
  selector: '[appLoadingAnimation]',
  standalone: false,
})
export class LoadingAnimationDirective implements OnInit, OnChanges {
  @HostBinding('style.position') hostPosition: string = 'relative';

  @Input() appLoadingAnimation: boolean = false;

  private readonly targetEl: ElementRef = inject(ElementRef);
  private readonly renderer: Renderer2 = inject(Renderer2);

  ngOnInit(): void {
    const loadingContainer: HTMLElement = this.renderer.createElement('div');
    this.renderer.addClass(loadingContainer, 'loading-container');
    this.renderer.setStyle(loadingContainer, 'display', this.appLoadingAnimation ? 'flex' : 'none');
    this.renderer.setStyle(loadingContainer, 'justify-content', 'center');
    this.renderer.setStyle(loadingContainer, 'align-items', 'center');
    this.renderer.setStyle(loadingContainer, 'position', 'absolute');
    this.renderer.setStyle(loadingContainer, 'top', '0');
    this.renderer.setStyle(loadingContainer, 'bottom', '0');
    this.renderer.setStyle(loadingContainer, 'left', '0');
    this.renderer.setStyle(loadingContainer, 'right', '0');
    this.renderer.setStyle(loadingContainer, 'background', 'white');

    const spinnerContainer: HTMLElement = this.renderer.createElement('div');
    this.renderer.addClass(spinnerContainer, 'loading-animation');

    this.renderer.appendChild(loadingContainer, spinnerContainer);

    this.renderer.appendChild(this.targetEl.nativeElement, loadingContainer);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.appLoadingAnimation) {
      const container: HTMLElement = this.targetEl.nativeElement;
      const div: HTMLElement | null = container.querySelector('.loading-container');
      if (div) {
        this.renderer.setStyle(div, 'display', this.appLoadingAnimation ? 'flex' : 'none');
      }
    }
  }

}
